import React, { useCallback, useEffect, useRef } from "react";
import * as S from "../CondensedFeatureGrid.styles";
import { ICondensedFeatureItem } from "../CondensedFeatureGrid.types";
import { useVideoCleanup } from "hooks/useDestroyVideoRef";

export const VideoItem = ({
  card,
  isActive,
  isInView,
}: Readonly<{
  card: ICondensedFeatureItem;
  isActive: boolean;
  isInView?: boolean;
}>) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  useVideoCleanup(videoRef);

  const playVideo = useCallback(async () => {
    try {
      await videoRef.current.play();
    } catch {}
  }, []);

  const pauseVideo = useCallback(async () => {
    try {
      videoRef.current.currentTime = 0;
      await videoRef.current.pause();
    } catch {}
  }, []);

  useEffect(() => {
    if (!card.assets?.src || !isInView || !isActive) {
      return;
    }

    playVideo();

    return () => {
      pauseVideo();
    };
  }, [isActive, card, playVideo, pauseVideo, isInView]);

  if (!card.assets?.src) {
    return <S.ImageBackground src={card.assets.poster} />;
  }

  return (
    <S.VideoBackground
      ref={videoRef}
      src={card.assets.src}
      poster={card.assets.poster}
      loop
      muted
      playsInline
      preload="none"
    />
  );
};
